import React from 'react';

import { injectIntl } from 'react-intl';
import { useOwner } from '../context/context.js';

import OwnerMenu from '../ui_items/OwnerMenu.js';
import { getRemotedbUrl } from '../../lib/ep.js';

const SecurityMainMenu = (props) => {
	const owner = useOwner();
	
	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false || parseInt(promotion.promo_type) < 1) return null;

	const selected = props?.selected ?? false;

	let _s = {};
	_s.general = {
		title:"General",
		items:[{
			url:`/promotions/profile/${promotion.id}`,
			icon:'knk-home',
			selected:(selected == 'profile') ? true : false,
			children:"Home",
		}],
	}

	_s.insights = {
		title:"Security Center",
		items:[{
			enabled:true,
			url:getRemotedbUrl(`/security_center/${promotion.id}`, 'main'),
			icon:'knk-to-do-list',
			selected:(selected == 'main') ? true : false,
			children:"Security level",
		}, {
			enabled:true,
			url:getRemotedbUrl(`/security_center/${promotion.id}`, 'ips'),
			icon:'knk-ip',
			selected:(selected == 'ips') ? true : false,
			children:"IP Address Analysis",
		}, {
			enabled:true,
			url:getRemotedbUrl(`/security_center/${promotion.id}`, 'domains'),
			icon:'knk-networks',
			selected:(selected == 'domains') ? true : false,
			children:"Email Domain Analysis",
		}, {
			enabled:false,
			url:getRemotedbUrl(`/security_center/${promotion.id}`, 'logs'),
			icon:'knk-script',
			selected:(selected == 'logs') ? true : false,
			children:"Activity log",
		}, {
			enabled:true,
			url:getRemotedbUrl(`/security_center/${promotion.id}`, 'alerts'),
			icon:'knk-alert',
			selected:(selected == 'alerts') ? true : false,
			children:"Blocked actions",
		}, {
			enabled:window.features.includes('headers_security'),
			url:getRemotedbUrl(`/security_center/${promotion.id}`, 'security-headers'),
			icon:'knk-csp-secure',
			selected:(selected == 'security-headers') ? true : false,
			children:"Security headers",
		}],
	}

	return (
		<OwnerMenu sections={Object.values(_s)} />
	)
}

export default injectIntl(SecurityMainMenu);